import { jsPDF } from 'jspdf';

const getLevelInfo = (level) => {
  const levels = {
    1: {
      name: 'Rastgele Sinyal Baskınlığı',
      practice: 'Nefes ritüellerine ve yavaş tempoya odaklanın. Dikkat dağıtıcıları ortadan kaldırın ve her oturuma sakin, merkezlenmiş bir zihinle yaklaşın. Oturumlar arasında farkındalık egzersizleri uygulayın.'
    },
    2: {
      name: 'Gelişmekte Olan Sezgisel Sinyal',
      practice: 'Yavaş, kasıtlı tempoya ve nefes tekniklerine devam edin. Analitik düşünme ve sezgisel algı arasındaki farkı fark edin. İnce izlenimlere güvenin.'
    },
    3: {
      name: 'Gelişen Psişik Duyarlılık',
      practice: 'Tutarlı pratik programları oluşturun. Birden fazla oturum genelinde kalıpları takip edin. Her oturumdan önce duygusal ve zihinsel durumunuzun farkında olun.'
    },
    4: {
      name: 'Aktif Sezgisel Algı',
      practice: 'Sonuçlarınızı istikrara kavuşturmaya odaklanın. Duygusal durumunuzun doğruluğu nasıl etkilediğini izleyin. Tutarlı algı seviyeleri korumak için topraklama tekniklerini uygulayın.'
    },
    5: {
      name: 'Yüksek Algısal Tutarlılık',
      practice: 'Düzenli pratik yoluyla uzun vadeli tutarlılığı koruyun. Kalıp analizi için oturumlarınızı belgeleyin. Bu kalibrasyon seviyesini sürdürmek için ileri düzey farkındalık eğitimini düşünün.'
    }
  };
  return levels[level] || levels[1];
};

export const generateSessionPDF = (session) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  let yPos = 20;
  
  // Header with dark band background
  doc.setFillColor(15, 15, 16);
  doc.rect(0, 0, pageWidth, 35, 'F');
  
  // Title
  doc.setTextColor(139, 92, 246);
  doc.setFontSize(24);
  doc.setFont('helvetica', 'bold');
  doc.text('Zener Mind', pageWidth / 2, 15, { align: 'center' });
  
  doc.setFontSize(12);
  doc.setTextColor(148, 163, 184);
  doc.text('Oturum Raporu', pageWidth / 2, 25, { align: 'center' });
  
  yPos = 50;
  
  // Session info
  doc.setTextColor(30, 30, 30);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  
  const dateTime = new Date(session.dateTime || Date.now()).toLocaleString('tr-TR');
  doc.text(`Tarih: ${dateTime}`, 20, yPos);
  yPos += 7;
  
  if (session.playerName) {
    doc.text(`Isim: ${session.playerName}`, 20, yPos);
    yPos += 7;
  }
  
  doc.text(`Oturum ID: ${session.sessionId}`, 20, yPos);
  yPos += 15;
  
  // Performance section
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(139, 92, 246);
  doc.text('Performans Ozeti', 20, yPos);
  yPos += 10;
  
  doc.setFontSize(10);
  doc.setTextColor(30, 30, 30);
  doc.setFont('helvetica', 'normal');
  
  const accuracy = ((session.hits / session.total) * 100).toFixed(1);
  doc.text(`Dogruluk: ${accuracy}% (${session.hits}/${session.total} isabet)`, 20, yPos);
  yPos += 7;
  
  doc.text(`En Iyi Seri: ${session.bestStreak}`, 20, yPos);
  yPos += 15;
  
  // Psychic Level section
  const levelInfo = getLevelInfo(session.level);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(6, 182, 212);
  doc.text('Mevcut Psissik Kalibrasyon Seviyesi', 20, yPos);
  yPos += 10;
  
  doc.setFontSize(12);
  doc.setTextColor(30, 30, 30);
  doc.text(`Seviye ${session.level} - ${levelInfo.name}`, 20, yPos);
  yPos += 15;
  
  // Symbol Performance Table
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(139, 92, 246);
  doc.text('Sembol Performansi', 20, yPos);
  yPos += 10;
  
  doc.setFontSize(9);
  doc.setTextColor(30, 30, 30);
  doc.setFont('helvetica', 'bold');
  doc.text('Sembol', 25, yPos);
  doc.text('Tahmin', 70, yPos);
  doc.text('Gercek', 115, yPos);
  doc.text('Isabet', 160, yPos);
  yPos += 7;
  
  doc.setFont('helvetica', 'normal');
  const symbolsTr = {
    circle: 'Daire',
    cross: 'Haç',
    waves: 'Dalgalar',
    square: 'Kare',
    star: 'Yildiz'
  };
  const symbols = ['circle', 'cross', 'waves', 'square', 'star'];
  symbols.forEach(symbol => {
    const stats = session.symbolStats[symbol];
    doc.text(symbolsTr[symbol], 25, yPos);
    doc.text(stats.guessed.toString(), 75, yPos);
    doc.text(stats.actual.toString(), 120, yPos);
    doc.text(stats.hits.toString(), 165, yPos);
    yPos += 6;
  });
  
  yPos += 10;
  
  // Practice Suggestion
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(139, 92, 246);
  doc.text('Pratik Onerisi', 20, yPos);
  yPos += 10;
  
  doc.setFontSize(10);
  doc.setTextColor(30, 30, 30);
  doc.setFont('helvetica', 'normal');
  const practiceLines = doc.splitTextToSize(levelInfo.practice, pageWidth - 40);
  doc.text(practiceLines, 20, yPos);
  yPos += practiceLines.length * 6 + 15;
  
  // Footer disclaimer
  if (yPos > 250) {
    doc.addPage();
    yPos = 20;
  }
  
  doc.setFontSize(8);
  doc.setTextColor(120, 120, 120);
  const disclaimer = 'Bu uygulama teshis, tahmin veya garanti edilmis yetenek degerlendirmesi saglamaz. Tum sonuclar, oz yansima ve egitim icin amaclanmis istatistiksel gozlemlerdir.';
  const disclaimerLines = doc.splitTextToSize(disclaimer, pageWidth - 40);
  doc.text(disclaimerLines, pageWidth / 2, yPos, { align: 'center' });
  
  // Save the PDF
  const fileName = `ZenerMind_Oturum_${session.sessionLabel.replace(/\s/g, '_')}_${dateTime.split(',')[0].replace(/\//g, '-')}.pdf`;
  doc.save(fileName);
};
